var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3014 18.4794L14.6073 13.7862C17.4336 10.393 17.0912 5.37692 13.8299 2.39934C10.5686 -0.578248 5.54207 -0.464012 2.4194 2.65866C-0.70327 5.78133 -0.817506 10.8078 2.16008 14.0691C5.13766 17.3304 10.1538 17.6729 13.547 14.8466L18.2401 19.5406C18.5332 19.8337 19.0083 19.8337 19.3014 19.5406C19.5944 19.2476 19.5944 18.7724 19.3014 18.4794ZM1.52073 8.50999C1.52073 4.78207 4.54281 1.75999 8.27073 1.75999C11.9987 1.75999 15.0207 4.78207 15.0207 8.50999C15.0207 12.2379 11.9987 15.26 8.27073 15.26C4.54452 15.2559 1.52486 12.2362 1.52073 8.50999Z",
    fill: "#3F71EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.79b044cb28b2742eb38d95274d659125.svg";
export { ForwardRef as ReactComponent };